var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('safe-img',{staticClass:"thumbnail",class:{ 'thumbnail--placeholder': _vm.hasPlaceholder },attrs:{"src":_vm.src,"placeholder":_vm.placeholder,"alt":_vm.alt},on:{"src-changed":function($event){_vm.hasPlaceholder = $event.isPlaceholder}}})}
var staticRenderFns = []

export { render, staticRenderFns }